import DefaultApiService from "./default";

const baseBySource = (source) =>
  source === "Management"
    ? "SLN/Management/ProjectWorkflowFoundation"
    : "SLN/SolarentOperator/ProjectWorkflowFoundation";

const roleBase = (role) => `SLN/${role}/ProjectExecutionPlans`;

const unwrapPayload = (res) => res?.data ?? res ?? null;

const ProjectExecutionPlanApi = {
  getActiveActivationsWithoutPlan: async (source) => {
    const res = await DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/GetActiveActivationsWithoutExecutionPlan`
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res) || [],
    };
  },

  createDraftExecutionPlan: async (source, payload) => {
    const res = await DefaultApiService.postApi(
      `${baseBySource(source)}/CreateDraftExecutionPlan`,
      payload
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },

  addExecutionMilestone: async (source, payload) => {
    const res = await DefaultApiService.postApi(
      `${baseBySource(source)}/AddExecutionMilestone`,
      payload
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },

  updateExecutionMilestone: async (source, payload) => {
    const res = await DefaultApiService.postApi(
      `${baseBySource(source)}/UpdateExecutionMilestone`,
      payload
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },

  submitExecutionPlan: async (source, payload) => {
    const res = await DefaultApiService.postApi(
      `${baseBySource(source)}/SubmitExecutionPlan`,
      payload
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },

  approveExecutionPlan: async (source, payload) => {
    const res = await DefaultApiService.postApi(
      `${baseBySource(source)}/ApproveExecutionPlan`,
      payload
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },

  changeExecutionMilestoneStatus: async (source, payload) => {
    const res = await DefaultApiService.postApi(
      `${baseBySource(source)}/ChangeExecutionMilestoneStatus`,
      payload
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },

  getExecutionPlanByActivation: async (source, projectExecutionActivationId) => {
    const res = await DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/GetExecutionPlanByActivation?projectExecutionActivationId=${projectExecutionActivationId}`
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },

  getExecutionPlansByRequest: async (source, requestId) => {
    const res = await DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/GetExecutionPlansByRequest?requestId=${requestId}`
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res) || [],
    };
  },

  getMyExecutionMilestones: async (role) => {
    const res = await DefaultApiService.getCustomeApi(
      `${roleBase(role)}/GetMyExecutionMilestones`
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res) || [],
    };
  },
};

export default ProjectExecutionPlanApi;
